module.exports = __webpack_public_path__ + "static/media/flip_to_front-24px.ab294c20.svg";